import Vue from "vue";
import Vuex from "vuex";
import { axios } from "../plugins/axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    parashah: {
      parashah: "",
      sheets: [],
      sefer: "",
    },
  },
  mutations: {
    parashah(state, parashahObject) {
      state.parashah = parashahObject;
    },
  },
  actions: {
    async getParashah({ commit }) {
      const { data } = await axios.get("/api/parashat-hashuvua");
      commit("parashah", data);
    },
  },
  modules: {},
});
